import { chakra } from "@chakra-ui/react"
import { inputRecipe } from "../../themes"

export const Input = chakra("input", inputRecipe)